import { Component, OnInit, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DeleteLocalCacheCategory, SharedService } from '@cfp/core';
import { ButtonLoading, CfpTranslateModule, FormGroupComponent, InputText, ModalContent } from '@cfp/ui';
import { LoadingSpinner } from '@cfp/ui/common';
import { AlertService } from '@cfp/ui/feedback';
import { BuildingCharacteristicsDTO, BuildingsService } from 'csr-asset-app';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  templateUrl: './building-code-modal.html',
  imports: [
    ModalContent,
    ButtonLoading,
    CfpTranslateModule,
    FormGroupComponent,
    InputText,
    ReactiveFormsModule,
    LoadingSpinner
  ]
})
export class BuildingCodeModal implements OnInit {
  public buildingId: number;

  protected readonly formGroup = signal<FormGroup | undefined>(undefined);
  protected readonly saving = signal<boolean>(false);

  private readonly buildingCharacteristics = signal<BuildingCharacteristicsDTO | undefined>(undefined);

  private readonly bsModalRef = inject(BsModalRef);
  private readonly formBuilder = inject(FormBuilder);
  private readonly buildingsService = inject(BuildingsService);
  private readonly sharedService = inject(SharedService);
  private readonly alertService = inject(AlertService);

  public ngOnInit(): void {
    this.getCharacteristics();
  }

  public hide(): void {
    this.bsModalRef.hide();
  }

  public save(): void {
    this.saving.set(true);
    const formGroup = this.formGroup();
    const buildingCharacteristics = this.buildingCharacteristics();
    if (!formGroup || formGroup.invalid || !buildingCharacteristics) {
      return;
    }

    formGroup.disable();
    const updatedBuildingCharacteristics = Object.assign(buildingCharacteristics, formGroup.value);
    this.buildingsService
      .v2BuildingsIdCharacteristicsPut(updatedBuildingCharacteristics, this.buildingId, false)
      .subscribe({
        next: () => {
          this.sharedService.emitDeleteLocalCache(DeleteLocalCacheCategory.Portfolio);
          this.sharedService.emitReloadComponent();
          this.alertService.showAlert('success', 'changed_saved');
          this.hide();
        },
        error: () => {
          this.saving.set(false);
          formGroup.enable();
          this.alertService.showAlert('error', 'error.general');
        }
      });
  }

  private getCharacteristics(): void {
    this.buildingsService.v2BuildingsIdCharacteristicsGet(this.buildingId).subscribe({
      next: (buildingCharacteristics: BuildingCharacteristicsDTO) => {
        this.buildingCharacteristics.set(buildingCharacteristics);

        this.formGroup.set(
          this.formBuilder.group({
            code: [buildingCharacteristics.code, []]
          })
        );
      },
      error: () => {
        this.alertService.showAlert('error', 'error.general');
      }
    });
  }
}
